import type { FC } from 'react'
import { createContext, useContext } from 'react'
import type { CmsLinkComponentProps } from '@/cms/components/cmsLink/CmsLink'
import type { SignInModalProps } from '@/content/components/membership/signInModal/SignInModal'
import type { PromoTilesProps } from '@/features/browsing/components/promoTiles/types'

interface OmniaComponentsContext {
    CmsLink: FC<CmsLinkComponentProps>
    SignInModal?: FC<SignInModalProps>
    PromoTiles?: FC<PromoTilesProps>
    mobileFetch?: typeof fetch
}

export const OmniaComponentsContext = createContext<OmniaComponentsContext>({} as OmniaComponentsContext)

export const useOmniaComponents = () => useContext(OmniaComponentsContext)
